let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dLaKS")).then(() => parcelRequire('cZ3Is'));